import { useMutation } from "@tanstack/react-query";
import { backendApi } from "../../api";
import { Polyp, RecommendationResponse } from "./interfaces";
import { enqueueSnackbar } from "notistack";

function getRecommendations(polyps: Polyp[]) {
  return backendApi<RecommendationResponse>({
    url: "/algorithms/recommendations",
    method: "POST",
    data: polyps,
  });
}

export function useGetRecommendations(
  onGetRecommendationSuccess: (data: RecommendationResponse) => void
) {
  return useMutation({
    mutationFn: async (polyps: Polyp[]) =>
      (await getRecommendations(polyps)).data,
    onSuccess: (data) => {
      onGetRecommendationSuccess(data);
    },
    onError: (error) => {
      console.log(error);
      // if (isAxiosError(error) && error.response?.status === 401) {
      //   localStorage.setItem(
      //     "next",
      //     window.location.pathname + window.location.search
      //   );
      //   window.location.reload();
      // }
      enqueueSnackbar("Getting recommendations failed", { variant: "error" });
    },
  });
}
